module.exports = __webpack_public_path__ + "static/media/recanto.b4507682.jpg";